<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="70%"
      mex-height="80%"
      :style="{ zIndex: options.zIndex }"
    >
    
      <v-card v-if="dialog">
        <v-card-title class="sticky-title">
          <h2>Prozesssteckbrief</h2>
          <v-chip
            class="ma-2"
            color="primary"
          >

            Ausgefüllt {{ nonEmptyFieldCount }} von {{ fieldCount }}
          </v-chip>
          <v-spacer />
          <v-btn
            v-if="!viewMode"
            color="primary"
            @click="addField"
          >
            Feld hinzufügen
          </v-btn>
          <!-- <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn> -->
        </v-card-title>
        <v-card-text class="p-0">
            <v-form v-model="valid">
            <v-container>
              <v-row id="rowContainer">
                <v-col cols="4">
                  Name des Prozesses
                </v-col>
                <v-col cols="8">
                  <v-text-field
                  label="Name des Prozesses"
                  v-model="processCharacteristic.name"
                  :disabled="viewMode"
                ></v-text-field>
                </v-col>
              </v-row>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Allgemeines
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row v-if="!openFromProcess" id="rowContainer">
                      <v-col>
                        <v-text-field
                          disabled
                          v-model="connectedModelData.fileName"
                          label="Verknüpftes BPMN-Modell"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="1" >
                        <v-btn fab small color="secondary" elevation="0">
                          <v-icon @click="editConnectedModel">edit</v-icon >
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-textarea
                        name="trigger"
                        label="Was ist der Prozessauslöser?"
                        required
                        v-model="processCharacteristic.trigger"
                        :disabled="viewMode"
                      ></v-textarea>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-textarea
                        name="outcome"
                        label="Was ist das Ergebnis des Prozesses?"
                        required
                        v-model="processCharacteristic.outcome"
                        :disabled="viewMode"
                      ></v-textarea>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-textarea
                        name="description"
                        label="Was sind die wichtigsten Schritte im Prozessablauf?"
                        required
                        v-model="processCharacteristic.description"
                        :disabled="viewMode"
                      ></v-textarea>
                    </v-row>
                    
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Schnittstellen/Beteiligte
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        Beteiligte Rollen
                      </v-col>
                      <v-col :cols="canAddItems ? '7':'8'">
                        <v-select
                          v-model="processCharacteristic.involvedRoles"
                          :items="roles"
                          item-text="friendlyName"
                          item-value="id"
                          attach
                          chips
                          label="Beteiligte Rollen"
                          multiple
                          :disabled="viewMode"
                        ></v-select>
                      </v-col>
                      <v-col cols="1" v-if="canAddItems">
                        <v-btn fab small color="primary" elevation="0">
                          <v-icon @click="openDialog('ROLE')">add</v-icon >
                        </v-btn>
                        {{ canAddItems }}
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        Abteilung
                      </v-col>
                      <v-col :cols="canAddItems ? '7':'8'">
                        <v-select
                          :items="departments"
                          item-text="friendlyName"
                          item-value="id"
                          label="Abteilung"
                          v-model="processCharacteristic.department"
                          :disabled="viewMode"
                        ></v-select>
                      </v-col>
                      <v-col cols="1" v-if="canAddItems">
                        <v-btn fab small color="primary" elevation="0">
                          <v-icon @click="openDialog('DEPARTMENT')">add</v-icon >
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        Schnittstellen zu anderen Abteilungen
                      </v-col>
                      <v-col cols="8">
                        <v-select
                          v-model="processCharacteristic.connectedDepartments"
                          :items="departments"
                          item-text="friendlyName"
                          item-value="id"
                          attach
                          chips
                          label="Schnittstellen zu anderen Abteilungen"
                          multiple
                          :disabled="viewMode"
                          :menu-props="{
                            maxHeight: '200px', // Adjust the max height as needed
                          }"
                        ></v-select>
                      </v-col>
                    </v-row>
                    <v-row id="rowContainer">
                      <v-col cols="4">
                        IT-Systeme
                      </v-col>
                      <v-col :cols="canAddItems ? '7':'8'">
                        <v-select
                          :disabled="viewMode"
                          v-model="processCharacteristic.systems"
                          :items="systems"
                          item-text="friendlyName"
                          item-value="id"
                          attach
                          chips
                          :menu-props="{ top: true, offsetY: true }"
                          label="IT-Systeme"
                          multiple
                        ></v-select>
                      </v-col>
                      <v-col cols="1" v-if="canAddItems">
                        <v-btn fab small color="primary" elevation="0">
                          <v-icon @click="openDialog('SYSTEM')">add</v-icon >
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Sonstiges
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div v-for="field in customFields" :key="field.key">
                      <v-row v-if="field.fieldType == 'SELECT'" id="rowContainer">
                        <v-col cols="4">
                          {{field.name}}
                        </v-col>
                        <v-col cols="8">
                          <v-select
                            v-model="customFieldValues[field.fieldId].value"
                            :items="field.options"
                            :label="field.name"
                            :disabled="viewMode"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row v-if="field.fieldType == 'NUMBER'" id="rowContainer">
                        <v-col cols="4">
                          {{field.name}}
                        </v-col>
                        <v-col cols="8">
                          <v-text-field
                            :label="field.name"
                            v-model="customFieldValues[field.fieldId].value"
                            type="number"
                            :disabled="viewMode"
                            :rules="minMaxRules"
                        ></v-text-field>
                        </v-col>
                      </v-row>
                    </div>
                    
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pr-6 pb-6 stickyFooter">
          <v-btn text @click.stop="close" id="leftButton">Schließen</v-btn>
          
          <v-tooltip top v-if="nonEmptyFieldCount != fieldCount">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="d-inline-block" id="rightButton"><v-btn style="width: 100%" elevation="0" v-if="!viewMode" v-on="on" :disabled="nonEmptyFieldCount != fieldCount" color="primary" @click="sendResponse()" >Speichern</v-btn></div>
            </template>
            <span>Alle Felder müssen ausgefüllt werden</span>
          </v-tooltip>
          <v-btn elevation="0" v-else-if="!viewMode" :disabled="nonEmptyFieldCount != fieldCount" color="primary" @click="sendResponse()" id="rightButton">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConnectedRessourceDialog ref="ressourceDialog"/>
    <AddCustomFieldDialog ref="customFieldDialog" />
    <choose-connected-process-dialog ref="connectedProcessDialog"/>
  </v-row>
</template>

<script>
import ConnectedRessourceDialog from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/ConnectedRessourceDialog.vue';
import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import AddCustomFieldDialog from './AddCustomFieldDialog.vue';
import processMapService from '@/components/processMapService.js';

import ChooseConnectedProcessDialog from './ChooseConnectedProcessDialog.vue';
import processModelingService from '../ProcessModeling/process-modeling-service';
export default {
  name: "NewProcessCharacteristicsDialog",
  components:{
    ConnectedRessourceDialog,
    AddCustomFieldDialog,
    ChooseConnectedProcessDialog
  },
  props: {
    openFromProcess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      minMaxRules: [
        v => !!v || "Dieses Feld muss ausgefüllt werden",
      ],
      dialog: false,
      roles: [],
      systems: [],
      departments:[],
      resolve: null,
      reject: null,
      connectedModelData: {
        fileName: null
      },
      message: null,
      title: null,
      viewMode: false,
      canSave: true,
      canAddItems: false,
      options: {
        width: 800,
        zIndex: 400,
      },
      processType: [
        {name: "Kernprozess", value: "CORE"},
        {name: "Führungsprozess", value:"LEADERSHIP"},
        {name: "Unterstützungsprozess", value:"SUPPORT"}
      ],
      highMidLowOptions: [
        {name: "Hoch", value: "HIGH"},
        {name: "Mittel", value: "MEDIUM"},
        {name: "Gering", value: "LOW"}
      ],
      processCharacteristic: {
        name: null,
        trigger: null,
        outcome: null,
        description: null,
        department: null,
        systems: null,
        connectedDepartments: [],
        involvedRoles: null,
        connectedProcesses: [],
        customFields: []

      },
      customFieldValues:{},
      characteristics: null,
      customFields: [],
      reloadAfterSave : false
      
    };
  },
  computed:{
    fieldCount(){
      let alwaysExcludeProperties = ["id", "connectedProcesses", "connectedModel", "connectedModelId", "customFields", "createdDate", "createdBy"];
      let filteredKeys = Object.keys(this.processCharacteristic).filter(key => !alwaysExcludeProperties.includes(key));
      return filteredKeys.length + this.customFields.length;
    },
    nonEmptyFieldCount(){
      return this.countNonEmptyProperties(this.processCharacteristic, 'customFields') + this.countNonEmptyProperties(this.customFieldValues, '');
    },
    async canEditProcessobjects(){
      let res = await this.$store.dispatch('hasPermission', 'EDIT_CONTEXTITEM');
      this.canAddItems = res;

    }
  },
  methods: {
    countNonEmptyProperties(obj, excludedPropertyName) {
      let alwaysExcludeProperties = ["id", "connectedprocesses", "connectedmodel", "connectedmodelid", "customfields", "createddate", "createdby"]
      let count = 0;

      // Recursive function to count non-empty properties
      const countProperties = (obj) => {

        for (const key in obj) {
          if (obj.hasOwnProperty(key) && key !== excludedPropertyName && !alwaysExcludeProperties.includes(key.toLowerCase())) {
            const value = obj[key];
            // Check if the value is not null and not undefined
            if (value !== null && value !== undefined) {
              // If it's an object, recursively count its non-empty properties
              if (typeof value === 'object' && value.value == null && typeof value.value == 'object') {
                countProperties(value.value);
              } else {
                // Otherwise, increment count if it's not an empty string or empty array
                if (!(Array.isArray(value) && value.length === 0) && value !== '') {
                  count++;
                }
              }
            }
          }
        }
      };

      // Start counting non-empty properties for customFieldValues object
      countProperties(obj);

      return count;
    },
    countNullAndEmptyProperties(obj, excludedPropertyName) {
      let count = 0;

      for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== excludedPropertyName) {
          const value = obj[key];
          if (value === null) {
            count++;
          } else if (Array.isArray(value) && value.length === 0) {
            count++;
          } /* else if (typeof value === 'object') {
            count += countNullAndEmptyArrays(value, excludedPropertyName); // Recursively check nested objects
          } */
        }
      }

      return count;
    },
    getCustomFieldValue(fieldId){
      let field = this.processCharacteristic.customFields.find(elem => elem.customFieldId == fieldId);
      if(field == null){
        this.processCharacteristic.customFields.push({
          customFieldId:fieldId,
          fieldValue: null
        })
      }
      return this.processCharacteristic.customFields.find(elem => elem.customFieldId == fieldId).fieldValue;
    },
    resetDefaultMap(){
      this.processCharacteristic = {
        name: null,
        trigger: null,
        outcome: null,
        description: null,
        department: null,
        systems: null,
        connectedDepartments: [],
        connectedModel: null,
        involvedRoles: null,
        connectedProcesses: [],
        customFields: []
      }
    },
    async loadRessources(){
      let res = await connectedRessourceService.retrieveConnectedRessources();
      this.departments = res.data.filter(elem => elem.type == "DEPARTMENT");
      this.systems = res.data.filter(elem => elem.type == "SYSTEM");
      this.roles = res.data.filter(elem => elem.type == "ROLE");
      let fieldValues = {};
      let response = await processMapService.getCustomFields();
      this.customFields = response.data;
        this.customFields.forEach(field => {
          fieldValues[field.fieldId] = {
            id: field.id,
            value: null
          }
          if(field.fieldType == "NUMBER"){
            this.minMaxRules.push(v => v < field.maxValue || "Wert zu groß. Maximum ist "+field.maxValue, v => v > field.minValue || "Wert zu klein. Minimum ist "+field.minValue);
          }
        })
        this.customFieldValues = { ...this.customFieldValues, ...fieldValues };
        this.dialog = true;
    },
    async open(characteristics, viewMode, filename = null) {
      console.log(characteristics)
      await this.loadRessources();
      this.viewMode = viewMode;
      if(characteristics != null){
        this.processCharacteristic = characteristics;
        if(this.processCharacteristic.customFields){
          this.processCharacteristic.customFields.forEach(elem => {
          this.customFieldValues[elem.customField.fieldId].value = elem.fieldValue;
        })
        }
      }
      console.log(this.processCharacteristic)
      if(this.processCharacteristic.connectedModel){
        processModelingService.retrieveModelInformation(this.processCharacteristic.connectedModel.uuid).then(resp => {
          this.connectedModelData = resp.data;
        })
      }
      if(filename){
        this.processCharacteristic.name = filename;
      }
      this.dialog = true;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },
    sendResponse(){
      if(this.processCharacteristic.customFields == null || this.processCharacteristic.customFields.length < 1){
        for(const [key, data] of Object.entries(this.customFieldValues)){
          this.processCharacteristic.customFields.push(
            {
              customFieldId: data.id,
              fieldValue: data.value
            }
          )
        }
      }else{
        for(const [key, data] of Object.entries(this.customFieldValues)){
          if(this.processCharacteristic.customFields.find(elem => elem.customField.id == data.id)) 
            this.processCharacteristic.customFields.find(elem => elem.customField.id == data.id).fieldValue = data.value;
        }
      }
      if(this.connectedModelData && this.connectedModelData.uuid) this.processCharacteristic.connectedModel = this.connectedModelData.uuid;
      this.resolve(this.processCharacteristic)
      this.resetDefaultMap();
      this.dialog = false;
    },
    close(){
      this.reject(this.processCharacteristic);
      this.resetDefaultMap();
      this.dialog = false;
    },
    openDialog(type){
      this.$refs.ressourceDialog
      .open(type, true, true)
      .then(() => this.loadRessources());
    },
    editConnectedModel(){
      this.$refs.connectedProcessDialog.open(this.processCharacteristic.connectedModelId, this.reloadAfterSave, this.processCharacteristic.id).then((res) => {
        if(res != null){
          processMapService.connectModelToCharacteristic(this.processCharacteristic.id, res.uuid).then(response => {
            this.processCharacteristic.connectedModelId = res.uuid;
            processModelingService.retrieveModelInformation(res.uuid).then(resp => {
              this.connectedModelData = resp.data;
              this.processCharacteristic.connectedModel = resp.data;
            })
          })
        }
      });
    },
    addField(){
      this.$refs.customFieldDialog
      .open()
      .then((res) => {
        let defaultVal = res.defaultValue;
        res.defaultValue = { type: (res.fieldType == 'NUMBER' ? 'NUMBER': 'OPTIONS'), value: defaultVal };
        res.defaultValue = JSON.stringify(res.defaultValue);
        processMapService.addCustomField(res).then(resp => {
          res.defaultValue = JSON.parse(res.defaultValue);
          res.id = resp;
          this.customFields.push(res);
        })
      });
    }
  }
};
</script>
<style scoped>
h3 {
  color: #575757;
}
.v-dialog{
  overflow-y: unset !important;
}
#cardFrame{
  border-radius: 10px;
  border: 1px solid #EFEFEF;
}
.svg-container {
  width: 5rem;
  height: 5rem;
}
#rowContainer{
  align-items:center
}
.v-expansion-panel-header{
  background-color: var(--v-background-base);;
}
.stickyFooter{
  position: sticky;
  bottom: 0; 
  background-color: white;
  z-index: 1001;
}
.formFrame{
  overflow-y: auto; 
  max-height: calc(100vh - 200px);
}

</style>